var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.btnFlag)?_c('div',{staticClass:"all"},[_c('div',{staticClass:"arrowTip",on:{"click":_vm.toTop}},[_c('i',{staticClass:"iconfont icon-arrowTop"})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }